/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ level: "average" | "good" | "low" }} Battery_LevelInputs */



/**
* | level | output |
* | --- | --- |
* | "average" | "Average" |
* | "good" | "Good" |
* | "low" | "Low" |
*
* @param {Battery_LevelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const battery_level = /** @type {((inputs: Battery_LevelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Battery_LevelInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.level === "average") return /** @type {LocalizedString} */ (`Average`);
		if (i?.level === "good") return /** @type {LocalizedString} */ (`Good`);
		if (i?.level === "low") return /** @type {LocalizedString} */ (`Low`);
		return /** @type {LocalizedString} */ ("battery_level");
	}
	{
		if (i?.level === "average") return /** @type {LocalizedString} */ (`Moyen`);
		if (i?.level === "good") return /** @type {LocalizedString} */ (`Bon`);
		if (i?.level === "low") return /** @type {LocalizedString} */ (`Faible`);
		return /** @type {LocalizedString} */ ("battery_level");
	}
});